import { render } from "./AnswerElement.vue?vue&type=template&id=2e7508e1&scoped=true"
import script from "./AnswerElement.vue?vue&type=script&lang=js"
export * from "./AnswerElement.vue?vue&type=script&lang=js"

import "./AnswerElement.vue?vue&type=style&index=0&id=2e7508e1&lang=css"
import "./AnswerElement.vue?vue&type=style&index=1&id=2e7508e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7508e1"]])

export default __exports__